<article class="school-card {{view}}"
         [attr.data-test]="'card_school'"
         [class.mobile]="deviceService.isMobile()"
         itemscope
         itemtype="https://schema.org/Product">

  <div class="card-cover" (click)="onOpenCardInModal()"></div>

  <div class="cover-wrap">
    <ng-container *ngTemplateOutlet="coverBlock"></ng-container>
    <div class="bookmark">
      <app-bookmark [notooltip]="true" [item]="school" [type]="'school'" (favoriteChanged)="favoriteChanged($event)"></app-bookmark>
    </div>
  </div>

  <div class="main-info-wrap">
    <div class="subject-wrap" *ngIf="subjects.length">
      <div class="subjects" [attr.data-test]="'card_school_subject'">
        <span class="subject" *ngFor="let subject of subjects.slice(0, 2); let last = last; trackBy: subjectsTrackByFn">
          {{ getSubjectTitle(subject) }}
          <span *ngIf="!last" class="comma">,</span>
        </span>
      </div>
      <ng-template [ngIf]="subjects?.length > 2">
        <span class="more-action">+{{ subjects.slice(2).length }}</span>
      </ng-template>
    </div>
    <div class="title" [attr.data-test]="'card_school_title'">
      <a [href]="schoolUrl" class="no-link">{{ title | striptags }}</a>
    </div>
    <div *ngIf="school.short_description" [attr.data-test]="'card_school_sub_title'">
      <p class="sub-title">{{ school.short_description | striptags }}</p>
    </div>

    <div class="statistics">
      <div class="classes-count">
        {{ 'teacher-card.stats.classes' | customLocale }} {{ school.stats?.meeting_count || 0 }}
      </div>

      <div class="separator"></div>

      <div class="participants-count">
        {{ 'school-card.students' | customLocale }} {{ school.stats?.participant_count || 0 }}
      </div>

      <ng-template [ngIf]="school.rating">
        <div class="separator"></div>
        <ng-container *ngTemplateOutlet="ratingWrap"></ng-container>
      </ng-template>
    </div>
  </div>
</article>


<ng-template #coverBlock>
  <div class="cover-block" [class.no-cover]="!coverImg">
    <ng-template [ngIf]="coverImg" [ngIfElse]="noCover">
      <on-ui-cover [cover]="coverImg" [scale]="doHover" [withBlur]="true" [attr.data-test]="'card_school_cover'"></on-ui-cover>
    </ng-template>
    <ng-template #noCover>
      <app-icon class="no-cover" icon="no-cover-square-new"
                [attr.data-test]="'card_school_cover'" [class.scale]="doHover"></app-icon>
    </ng-template>
  </div>
</ng-template>


<ng-template #ratingWrap>
  <app-rating [stats]="school" [label]="true"></app-rating>
</ng-template>
